import * as PIXI from 'pixi.js'
import { TweenMax, TimelineMax, Power0, Power1, Power2, Power3, Power4, Back, Bounce, Elastic, Expo, Sine } from 'gsap'
import { trace } from 'rytm-helpers'
import { scaleToPx, absPositionX, absPositionY, relPositionX, relPositionY } from './../lib/math_helpers'


class VisualObject {
  /**
  * VisualObject class constructor  
  * @constructor
  **/
  constructor(params) {
    this.id = params.id
    this.bar = params.bar // bar number
    this.onReady = params.onReady ? params.onReady : () => {}
    this.onStage = false
    this.uid = null // set when added to stage
    this._orygWidth = null
    this._orygHeight = null
    this.x = 0
    this.y = 0
    this.scale = .1
  }
  /**
   * Destroy
   */
  destroy() {
    this.onStage = false
    if (this.sprite) {
      this.sprite.parent.removeChild(this.sprite)
      this.sprite = null
      this._orygWidth = null
      this._orygHeight = null
      // trace("Destroy!", this.uid, this)
    }
  }
  buildSprite() {
    const texturePath = this._getTexturePath()
    this.texture = PIXI.utils.TextureCache[texturePath]
    if (this.texture) {
      this.sprite = new PIXI.Sprite(this.texture)
      this.onTextureReady()
    } else {
      this.texture = new PIXI.Texture.from(texturePath)
      this.texture.on('update', this.onTextureReady.bind(this))
      this.sprite = new PIXI.Sprite(this.texture)
    } 
  }
  onTextureReady() {
    if (!this._fired_once) {
      const w = this.sprite.width
      const h = this.sprite.height
      this._fired_once = true
      this._orygWidth =  w
      this._orygHeight = h
      this._update()
      this.onReady()
    }
  }
  /**
   * Add to stage
   */
  addToStage(container) {
    container.addChild(this.sprite)
    this.onStage = true
    this._update()
    this.sprite.anchor.set(.5)
    this._show()
  }
  /**
   * Set position relative to window width
   * @param {Object} params 
   */
  setPosition(params) {
    this.x = params.x ? params.x : this.x
    this.y = params.y ? params.y : this.y
    this._update()
  }
  /**
   * Set scale relative to window width
   * @param {Number} scale
   */
  setScale(scale) {
    this.scale = scale
    this._update()
  }
  /**
   * Vertical align
   * @param {Number} offset 
   */
  verticalAlign(offset = 0) {
    const h = this._getCurrentHeight()
    this.y = .5 - relPositionY(h) * .5 + offset
    this._update()
  }
  /**
   * Czy obiekt jest poza zasięgiem wizualnym
   * @return Boolean
   */
  isInsideBounds() {
    return this.x > -1 && this.x < 1.5 && this.y > -2 && this.y < 2
  }
  onWindowResize() {
    this._update()
  }
  // get relative width
  getWidth() {
    return this._getCurrentWidth() / window.innerWidth
  }
  // get relative height
  getHeight() {
    return this._getCurrentHeight() / window.innerWidth
  }
  // get Rect
  getRect() {
    return {
      x: absPositionX(this.x),
      y: absPositionY(this.y),
      width: this.getWidth(),
      height: this.getHeight()
    }
  }
  
  /** 
   * ### PRIVATE METHODS ###
   */
  _show() {
    switch (this.id) {
      case "circle":
        const t = new TimelineMax({repeat: 0})
        t.from(this.sprite, .2, {alpha: 0})
        t.to(this.sprite, .5, {alpha: 0, delay: .5})
      case "star":
        const startW = this.sprite.width * .1 
        const startH = this.sprite.height * .1 
        TweenMax.from(this.sprite, .1, {width: startW, height: startH, ease: Back.easeOut})
        break;
      default:
        const startX = this.sprite.x + window.innerWidth * .5
        TweenMax.from(this.sprite, .1, {x: startX, ease: Expo.easeOut})
        break;
    }
    
  }
  _getCurrentWidth() {
    const scale = this._translateScale(this.scale)
    return this._orygWidth * scale
  }
  _getCurrentHeight() {
    const scale = this._translateScale(this.scale)
    return this._orygHeight * scale
  }
  _translateScale(d) {
    if (!this._orygWidth || !this._orygHeight) {
      return 1
    }
    // width vs height (take the longer one)
    const a = this._orygWidth > this._orygHeight ? this._orygWidth : this._orygHeight
    const destW = scaleToPx(d)
    return destW / a
  }
  _getCoordinates() {
    return {
      x: absPositionX(this.x),
      y: absPositionY(this.y),
      width: this._translateScale(this.scale) * this._orygWidth,
      height: this._translateScale(this.scale) * this._orygHeight,
      scale: this._translateScale(this.scale)
    }
  }
  _getTexturePath() {
    return '/local/assets/2020/textures/' + this.id + '.svg'
  }
  _update() {
    if (this.onStage && this._orygWidth && this._orygHeight) {
      let p = this._getCoordinates()
      this.sprite.x = p.x
      this.sprite.y = p.y
      this.sprite.width = p.width
      this.sprite.height = p.height
    }
  }


}

export default VisualObject;
